var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1784 10L15.5892 5.58916C15.915 5.26416 15.915 4.73588 15.5892 4.41088C15.2634 4.08505 14.7367 4.08505 14.4109 4.41088L10 8.82169L5.58921 4.41088C5.26338 4.08505 4.73671 4.08505 4.41088 4.41088C4.08505 4.73588 4.08505 5.26416 4.41088 5.58916L8.82171 10L4.41088 14.4109C4.08505 14.7359 4.08505 15.2642 4.41088 15.5892C4.57338 15.7517 4.78671 15.8334 5.00005 15.8334C5.21338 15.8334 5.42671 15.7517 5.58921 15.5892L10 11.1784L14.4109 15.5892C14.5734 15.7517 14.7867 15.8334 15 15.8334C15.2134 15.8334 15.4267 15.7517 15.5892 15.5892C15.915 15.2642 15.915 14.7359 15.5892 14.4109L11.1784 10Z",
    fill: "#60646C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.667251e8269f37e6db2d6c43a93cee61.svg";
export { ForwardRef as ReactComponent };